import React from "react";
import TextField from '../Form/TextField';
import useTheme from '../../hooks/useTheme';

export default function DeliveryForm(props) {
    const {
        formData,
        handleChange
    } = props;
    const theme = useTheme();
  const isDelivery = formData.orderType === 'delivery';
  const isDriveThrough = formData.orderType === 'drive_through';
  
  return (
    <div className="flex flex-col">
      <h1 className="text-xl md:text-2xl poppins pb-3 md:pb-4 border-b border-gray-500 text-gray-700">
        {isDelivery ? 'Edit Delivery Details' : isDriveThrough ? 'Edit Drive Through Details' : 'Edit Customer Details'}
      </h1>
      <form className="my-3 md:my-4" >
        <div className="flex flex-col space-y-3 md:space-y-3">
          {!isDriveThrough && (
            <TextField
              type="text"
              placeholder="Name (Optional)"
              name="name"
              value={formData.name}
              onChange={handleChange}
            />
          )}
          {isDelivery && (
            <>
              <TextField
                type="text"
                placeholder="Flat or Building Name"
                name="building"
                value={formData.building}
                onChange={handleChange}
                required
              />
              <TextField
                type="text"
                placeholder="Area"
                name="area"
                value={formData.area}
                onChange={handleChange}
                required
              />
              <TextField
                type="text"
                placeholder="District"
                name="district"
                value={formData.district || ""}
                onChange={handleChange}
                required
              />
              <TextField
                type="text"
                placeholder="Pin Code"
                name="pinCode"
                value={formData.pinCode || ""}
                onChange={handleChange}
                required
              />
            </>
          )}
          <TextField
            type="text"
            placeholder="Mobile Number (Optional)"
            name="mobile"
            value={formData.mobile}
            onChange={handleChange}
          />
          
          {/* Payment Method Selection */}
          <div className="relative w-full px-4 py-4 rounded-lg border border-gray-300 bg-white">
            <div className="flex flex-col space-y-2.5">
              <label className="flex items-center space-x-3 cursor-pointer group">
                <input
                  type="radio"
                  name="paymentMethod"
                  value="cash_on_delivery"
                  checked={formData.paymentMethod === 'cash_on_delivery'}
                  onChange={handleChange}
                  className="w-5 h-5 cursor-pointer focus:outline-none"
                  style={{ accentColor: theme.colors.primaryColor }}
                />
                <span className="text-sm text-gray-700 group-hover:text-gray-900 font-medium">
                  💵 Cash
                </span>
              </label>
              
              <label className="flex items-center space-x-3 cursor-pointer group">
                <input
                  type="radio"
                  name="paymentMethod"
                  value="card"
                  checked={formData.paymentMethod === 'card'}
                  onChange={handleChange}
                  className="w-5 h-5 cursor-pointer focus:outline-none"
                  style={{ accentColor: theme.colors.primaryColor }}
                />
                <span className="text-sm text-gray-700 group-hover:text-gray-900 font-medium">
                  💳 Card
                </span>
              </label>
              
              <label className="flex items-center space-x-3 cursor-pointer group">
                <input
                  type="radio"
                  name="paymentMethod"
                  value="upi"
                  checked={formData.paymentMethod === 'upi'}
                  onChange={handleChange}
                  className="w-5 h-5 cursor-pointer focus:outline-none"
                  style={{ accentColor: theme.colors.primaryColor }}
                />
                <span className="text-sm text-gray-700 group-hover:text-gray-900 font-medium">
                  📱 UPI
                </span>
              </label>
            </div>
          </div>
          
          {isDriveThrough && (
            <>
              <TextField
                type="text"
                placeholder="Estimated Time (Optional) - e.g., 2:30 PM, 15 minutes"
                name="estimatedTime"
                value={formData.estimatedTime}
                onChange={handleChange}
              />
              <TextField
                type="text"
                placeholder="Vehicle Number (Optional)"
                name="vehicleNumber"
                value={formData.vehicleNumber}
                onChange={handleChange}
              />
            </>
          )}
          <TextField
            type="text"
            placeholder="Additional Notes (Optional)"
            name="kitchenNotes"
            value={formData.kitchenNotes}
            onChange={handleChange}
          />
          
          {/* Use Current Location Checkbox - Only show for delivery orders */}
          {isDelivery && (
            <div className="mt-4 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl border border-blue-200 hover:border-blue-300 transition-all duration-300">
              <div className="flex items-center space-x-3">
                <div className="relative">
                  <input
                    type="checkbox"
                    id="useCurrentLocation"
                    name="useCurrentLocation"
                    checked={formData.useCurrentLocation || false}
                    onChange={handleChange}
                    className="w-5 h-5 bg-white border-2 border-blue-300 rounded-md focus:ring-blue-500 focus:ring-2 focus:ring-offset-2 cursor-pointer transition-all duration-200"
                    style={{
                      backgroundImage: formData.useCurrentLocation ? 'url("data:image/svg+xml,%3csvg viewBox=\'0 0 16 16\' fill=\'white\' xmlns=\'http://www.w3.org/2000/svg\'%3e%3cpath d=\'m13.854 3.646-7.5 7.5a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6 10.293l7.146-7.147a.5.5 0 0 1 .708.708z\'/%3e%3c/svg%3e")' : 'none',
                      backgroundColor: formData.useCurrentLocation ? '#2563eb' : 'white',
                      WebkitAppearance: 'none',
                      MozAppearance: 'none',
                      appearance: 'none'
                    }}
                  />
                </div>
                <div className="flex-1">
                  <label htmlFor="useCurrentLocation" className="flex items-center space-x-2 cursor-pointer">
                    <span className="text-2xl">📍</span>
                    <div>
                      <div className="text-sm font-semibold text-gray-800">
                        Use my current location for delivery
                      </div>
                      <div className="text-xs text-gray-600 mt-1">
                        Share your GPS coordinates for accurate delivery
                      </div>
                    </div>
                  </label>
                </div>
              </div>
            </div>
          )}
        </div>
      </form>
    </div>
  );
}
